import { createSlice } from "@reduxjs/toolkit";
export const modalToShow = createSlice({
  name: "modalToShow",
  initialState: {
    componentName: null,
  },
  reducers: {
    setComponentToShow(state, action) {
      state.componentName = action.payload;
    },
  },
});
export const { setComponentToShow } = modalToShow.actions;
export default modalToShow.reducer;
